;(function($, undefined){
    var rnn = window.rnn,
        log = rnn.logging.log;

    function show(notification) {
        /**
         * Show this notification to the user.
         *
         * Example notification = {
         *     level: 20,
         *     body: 'You have receieved a badge.',
         *     tags: 'info badge'
         * }
         *
         * The notification.body value can be in JSON format
         * if it is a growl-like notification.
         */
        log('Recieved notification:', notification);
        if (typeof(notification.body) == 'object') {
            showGrowl(notification);
        } else {
            showSimple(notification);
        }
    }

    function showGrowl(notification) {
        // TODO: Use notification.tags for html class names.
        // TODO: Call some pretty notification stuff with title, body, image (optional)
        var growl = notification.body;
        alert(growl.title + '\n' + growl.body + '\n' + (growl.image || ''));
    }

    function showSimple(notification) {
        rnn.modules.alert.show($(rnn.site.notificationWrapperClass), {
            'message': notification.body,
            'stick': true,
            'type': notification.tags
        });
    }

    function removeAllSimple() {
        $(rnn.site.notificationWrapperClass + ' .alert').slideUp(200, function(){
            $(this).remove();
        });
    }

    function initNotifications() {
        rnn.modules.user.get(function(user) {
            if (user.notifications) {
                $(user.notifications).each(function() {
                    show(this);
                });
            }
        });
    }

    // Convenience methods to show simple success or info, one at a time.

    function error(message) {
        removeAllSimple();
        showSimple({'body': message, 'tags': 'error'});
    }

    function info(message) {
        removeAllSimple();
        showSimple({'body': message, 'tags': 'info'});
    }

    function success(message) {
        removeAllSimple();
        showSimple({'body': message, 'tags': 'success'});
    }

    rnn.modules.register('notifications', {
        init: initNotifications,
        error: error,
        info: info,
        success: success
    });

})(jQuery);
